import { useCallback } from 'react'
import type { LocationInfoData } from 'tripPlanner/components/Chat/Message'
import type { OfferClickSearchParams } from '../contexts/ChatMessageActionsContext'
import { useDrawerSlot, type DrawerSlot } from './useDrawerSlot'

export interface PlaceDetails {
  readonly googlePlaceId: string
  readonly placeName: string
  readonly countryName?: string
  readonly stopId?: number
}

export interface InlinePlace {
  readonly googlePlaceId: string
  readonly placeName: string
}

export interface OfferDrawerData {
  readonly offerId: string
  readonly searchParams?: OfferClickSearchParams
  readonly offerType?: string
  readonly scrollToPricing?: boolean
  readonly scrollToRoomOptions?: boolean
}

export interface UseDrawerStateReturn {
  detailPanel: DrawerSlot<PlaceDetails>
  placeInfo: DrawerSlot<InlinePlace>
  locationInfo: DrawerSlot<LocationInfoData>
  offerDrawer: DrawerSlot<OfferDrawerData>
  resetDrawers: () => void
}

export function useDrawerState(): UseDrawerStateReturn {
  const detailPanel = useDrawerSlot<PlaceDetails>()
  const placeInfo = useDrawerSlot<InlinePlace>()
  const locationInfo = useDrawerSlot<LocationInfoData>()
  const offerDrawer = useDrawerSlot<OfferDrawerData>()

  const resetDrawers = useCallback(() => {
    detailPanel.reset()
    placeInfo.reset()
    locationInfo.reset()
    offerDrawer.reset()
  }, [detailPanel, placeInfo, locationInfo, offerDrawer])

  return {
    detailPanel,
    placeInfo,
    locationInfo,
    offerDrawer,
    resetDrawers,
  }
}
